import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnchor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnchor1"><Path fillRule="evenodd" clipRule="evenodd" d="M12.9996 8.85517C14.4456 8.42501 15.5 7.08564 15.5 5.5C15.5 3.567 13.933 2 12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.08538 9.55408 8.42456 10.9996 8.85495V20H6.48972L4.35083 13H6.99963V11H1.64844L5.00955 22H18.9897L22.3508 11H16.9996V13H19.6484L17.5095 20H12.9996V8.85517ZM10.5 5.5C10.5 4.67157 11.1716 4 12 4C12.8284 4 13.5 4.67157 13.5 5.5C13.5 6.32843 12.8284 7 12 7C11.1716 7 10.5 6.32843 10.5 5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnchor1;
